<script>
import { authComputed } from '@state/helpers'
import { Sketch } from 'vue-color'

export default {
  components: { Sketch },
  data() {
    return {
      color: '#3bafda',
      preset_colors: [
        '#3bafda',
        '#ff758e',
        '#37bd85',
        '#6572b8',
        '#ffc425',
        '#666666',
        '#ff8a23',
        '#90C3D6',
      ],
      tooSmall: false,
    }
  },
  computed: {
    ...authComputed,
  },
  created() {
    if(localStorage.getItem("theme")){ document.body.style.setProperty('--theme', localStorage.getItem("theme")); }
    if(localStorage.getItem("theme-rbg")){ document.body.style.setProperty('--theme-rbg', localStorage.getItem("theme-rbg")); }

    if(window.innerWidth < 1600) { this.tooSmall = true; } else { this.tooSmall = false; }
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
    // changeColor2(pic) {
    //   document.body.style.setProperty('--theme', pic);
    //   localStorage.setItem('theme', pic);
    // },
    changeColor() {
      if(this.color && this.color.hex) {
        // console.log(this.color);
        document.body.style.setProperty('--theme', this.color.hex);
        localStorage.setItem('theme', this.color.hex);
      }
      if(this.color && this.color.rgba.r && this.color.rgba.g && this.color.rgba.b) {
        // console.log(this.color);
        var rgb = this.color.rgba.r+', '+this.color.rgba.g+', '+this.color.rgba.b;
        document.body.style.setProperty('--theme-rbg', rgb);
        localStorage.setItem('theme-rbg', rgb);
      }
    },
  },
}
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar-admin">
    <ul class="list-unstyled topnav-menu float-right mb-0">

      <b-nav-item-dropdown right class="notification-list" menu-class="p-0">
        <template slot="button-content">
          <Icon icon="ri:brush-2-line" height="22" v-tippy content="Change theme"></Icon>
        </template>
        <b-dropdown-text class="p-0" text-class="p-0">
          <Sketch v-model="color" :preset-colors="preset_colors" @input="changeColor" />
        </b-dropdown-text>
      </b-nav-item-dropdown>

      <b-nav-item-dropdown right class="profile-dropdown">
        <template slot="button-content">
          <div class="text-white">
             {{user ? user.name : ''}} <Icon icon="ri:arrow-down-s-line" height="15"></Icon>
             <img v-if="user.avatar" :src="formatImage(user.avatar)" class="_w-50 d-inline-block rounded ml-2">
             <avatar v-else :username="user.name" :size="50" :rounded="false" class="d-inline-block rounded ml-2"></avatar>
          </div>
        </template>
        <b-dropdown-header id="dropdown-header-label" class="noti-title">
          <h6 class="text-overflow m-0">Welcome !</h6>
        </b-dropdown-header>
        <b-dropdown-item v-if="hasRole(['Dev','Admin'])">
          <router-link :to="'/users/'+user.id" tag="a" class="_c-pointer" exact>
            <Icon icon="ri:account-box-line" class="mr-2"></Icon>
            <span>My Account</span>
          </router-link>
        </b-dropdown-item>
        <b-dropdown-item href="/logout">
          <Icon icon="ri:logout-box-r-line" class="mr-2"></Icon>
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </ul>

    <div class="logo-box">
      <a :href="app_url" class="logo text-center">
        <span class="logo-lg">
          <img src="@assets/images/logo-sm.png" alt="" height="19" class="rotateme" />
          <span class="logo-lg-text-light align-top ml-1 text-uppercase">{{app_name}}</span>
        </span>
        <span class="logo-sm">
          <img src="@assets/images/logo-sm.png" alt="" height="24" class="rotateme" />
        </span>
      </a>
    </div>

    <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
      <li>
        <button class="button-menu-mobile waves-effect waves-light" @click="toggleMenu">
          <Icon icon="ri:menu-line" height="22" class="mb-1" />
        </button>
      </li>
      <li><div v-if="tooSmall" class="alert alert-warning small mt-2 _c-pointer" @click="tooSmall = false" v-tippy content="Close"><Icon icon="ri:close-line" class="mr-2"></Icon> A screen width of 1600px or greater is recommended.</div></li>
    </ul>
  </div>
</template>

<style lang="scss">
.notification-items {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
body .vc-sketch {
  box-shadow: none;
}
</style>
